export { PresentationChartBar as default } from './PresentationChartBar';
